// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  itemId: __t.u64().primaryKey().name("item_id"),
  owner: __t.identity(),
  assetId: __t.u64().name("asset_id"),
  nextOwnerCopy: __t.bool().name("next_owner_copy"),
  nextOwnerModify: __t.bool().name("next_owner_modify"),
  nextOwnerTransfer: __t.bool().name("next_owner_transfer"),
  acquiredAt: __t.timestamp().name("acquired_at"),
});
